import * as React from "react";

export type InputWithKebabMenuVariant = "form" | "table";

export interface IInputWithKebabMenuProps {
    children?: React.ReactNode;
    kebab?: React.ReactNode;
    variant?: InputWithKebabMenuVariant;
    className?: string;
    isHidden?: boolean;
}

const InputWithKebabMenu: React.FC<IInputWithKebabMenuProps> = ({
    children,
    kebab,
    variant = "table",
    className,
    isHidden,
}) => {
    if (isHidden) {
        return null;
    }

    return (
        <div
            className={[
                "inputWithKebabMenu",
                `inputWithKebabMenu--${variant}`,
                className,
            ].filter(Boolean).join(" ")}
            data-testid="input-with-kebab-menu"
        >
            {children != null && children !== false ? (
            <div className="inputWithKebabMenu__field">
                {children}
            </div>
            ) : null}
            {kebab ? (
                <div className="inputWithKebabMenu__kebab">
                    {kebab}
                </div>
            ) : null}
        </div>
    );
};

export default InputWithKebabMenu;
